import { ShoppingCartService } from '../shopping-cart/shopping-cart.service';
import { RequestModel } from '../shopping-cart/request-model.model';
import { Component, OnInit, ViewChild, OnDestroy } from '@angular/core';
import { IndProvModalComponent } from './ind-prov-modal/ind-prov-modal.component';
import { faUser } from '@fortawesome/free-solid-svg-icons';
import { faStoreAlt } from '@fortawesome/free-solid-svg-icons';
import { ConfirmModalComponent } from './confirm-modal/confirm-modal.component';
import { DentPracModalComponent } from './dent-prac-modal/dent-prac-modal.component';
import { Subscription } from 'rxjs';
import { EventService } from './event-service/event.service';

@Component({
  selector: 'app-main',
  templateUrl: './main.component.html',
  styleUrls: ['./main.component.scss']
})
export class MainComponent implements OnInit, OnDestroy {
  public faUser = faUser;
  public faStoreAlt = faStoreAlt;
  public requests: RequestModel[] = [];
  public reqType: string;
  public validReq = false;
  public group: boolean;
  private subscriptions: Subscription[] = new Array<Subscription>();
  @ViewChild(IndProvModalComponent, { static: true }) indProvModal: IndProvModalComponent;
  @ViewChild(ConfirmModalComponent, { static: true }) confirmModal: ConfirmModalComponent;
  @ViewChild(DentPracModalComponent, { static: true }) dentPracModal: DentPracModalComponent;

  constructor(
    private cartService: ShoppingCartService,
    private eventService: EventService
  ) {}

  ngOnInit() {
    this.requests = this.cartService.getCart();

    this.subscriptions.push(
      this.eventService.confirmEvent.subscribe(confirmEvent => {
        if (confirmEvent) {
          this.validReq = confirmEvent.validRequest;
        }
        
        if (this.validReq === true) {
          if (confirmEvent) {
            this.reqType = confirmEvent.reqType;
            this.group = confirmEvent.group;
            this.showConfirmModal(this.reqType, this.group);
          }
        }
      })
    );
  }

  ngOnDestroy(): void {
    this.subscriptions.forEach(subscription => {
      if (!subscription.closed) {
        subscription.unsubscribe();
      }
    });
  }

  public showIndProvModal(): void {
    this.indProvModal.openModalWithClass();
  }

  public showDentPracModal(): void {
    this.dentPracModal.openModalWithClass();
  }

  public showConfirmModal(request: string, group: boolean): void {
    if (group === true) {
      this.confirmModal.requestType = 'Dental practice';
    }
    else {
      this.confirmModal.requestType = 'Individual provider';
    }

    if (request === 'new') {
      this.confirmModal.request = 'add';
    }
    else if (request === 'res') {
      this.confirmModal.request = 'delet';
    }
    else {
      this.confirmModal.request = 'updat';
    }

    this.confirmModal.openModalWithClass();
  }
}
